import { render, staticRenderFns } from "./ParcelDetail.vue?vue&type=template&id=55acbf88"
import script from "./ParcelDetail.vue?vue&type=script&lang=js"
export * from "./ParcelDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports